var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullscreenloading,
          expression: "fullscreenloading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { name: "info" } }, [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _c("svg-icon", { attrs: { "icon-class": "hike" } }),
                _vm._v("Subscription Info"),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "fieldset",
              { staticClass: "otrfieldset" },
              [
                _c("legend", [_vm._v("General")]),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("ID:"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("span", [_c("b", [_vm._v(_vm._s(_vm.form.id))])]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Tenant"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getTenantLabel(_vm.form.tenant))),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Organization"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item",
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "Select Organization",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "organization", $$v)
                              },
                              expression: "form.organization",
                            },
                          },
                          _vm._l(_vm.organizations, function (org) {
                            return _c("el-option", {
                              key: org.id,
                              attrs: { label: org.name, value: org.name },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Title"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { placeholder: "Subscription Title" },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-top": "5px",
                            },
                          },
                          [_vm._v("e.g. ABC Company Development Program 2026")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Start date"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "Pick a day",
                          },
                          model: {
                            value: _vm.form.startDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startDate", $$v)
                            },
                            expression: "form.startDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("End date"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "Pick a day",
                          },
                          model: {
                            value: _vm.form.endDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endDate", $$v)
                            },
                            expression: "form.endDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Status:"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item",
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "Select Status" },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "Published", value: "Published" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "Archived", value: "Archived" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "fieldset",
              {
                staticClass: "otrfieldset",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c("legend", [_vm._v("Related programs")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "15px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", icon: "el-icon-plus" },
                        on: { click: _vm.openLoopDialog },
                      },
                      [_vm._v("Add Loop")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.loops.length > 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          border: "1px solid #dcdfe6",
                          "border-radius": "4px",
                          padding: "15px",
                          "background-color": "#fafafa",
                          "max-width": "800px",
                        },
                      },
                      _vm._l(_vm.form.loops, function (loop, idx) {
                        return _c(
                          "div",
                          {
                            key: loop.id,
                            staticStyle: {
                              "margin-bottom": "20px",
                              "border-bottom": "1px dashed #dcdfe6",
                              "padding-bottom": "15px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                  "font-weight": "bold",
                                  "font-size": "15px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Loop: " + _vm._s(loop.title) + " "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            color: "#909399",
                                            "font-weight": "normal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "(ID: " + _vm._s(loop.id) + ")"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: {
                                          href: "/#/loop/edit/" + loop.id,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { padding: "4px 8px" },
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("Open")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-button", {
                                  attrs: {
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    size: "mini",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeLoop(idx)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#909399",
                                      "margin-bottom": "5px",
                                    },
                                  },
                                  [_vm._v("Hikes:")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: loop.hikes,
                                      size: "mini",
                                      border: "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { label: "Hike ID", width: "180" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(_vm._s(scope.row.id)),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: { label: "Hike Title" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "space-between",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(scope.row.title)
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "/#/hike/edit/" +
                                                            scope.row.id,
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticStyle: {
                                                              padding:
                                                                "4px 8px",
                                                            },
                                                            attrs: {
                                                              type: "primary",
                                                              size: "mini",
                                                            },
                                                          },
                                                          [_vm._v("Open")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#909399",
                          "font-style": "italic",
                        },
                      },
                      [_vm._v("No training programs (Loops) added yet.")]
                    ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { name: "coaching", label: "1:1 Coaching" } },
            [
              _c(
                "fieldset",
                { staticClass: "otrfieldset" },
                [
                  _c("legend", [_vm._v("Unlock 1:1 Coaching criteria")]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Check-in passing rate %:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 20 } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                min: 0,
                                max: 100,
                                size: "small",
                                "controls-position": "right",
                              },
                              model: {
                                value: _vm.form.performance.checkinPassingRate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.performance,
                                    "checkinPassingRate",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.performance.checkinPassingRate",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "margin-left": "5px",
                                  color: "#606266",
                                },
                              },
                              [_vm._v("%")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm._v(
                              "Target check-in passing rate for users (0 - 100, default 80)."
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Minimum number of steps:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              min: 0,
                              size: "small",
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.performance.minimumStepCount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.performance,
                                  "minimumStepCount",
                                  $$v
                                )
                              },
                              expression: "form.performance.minimumStepCount",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "5px",
                              },
                            },
                            [
                              _vm._v(
                                "Minimum required steps for completion (default 0)."
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      style:
                        _vm.mandatoryHikeActivities.length === 0
                          ? "display: flex; align-items: center;"
                          : "",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Mandatory Hike activities:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 20 } }, [
                        _vm.mandatoryHikeActivities.length > 0
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.mandatoryHikeActivities,
                                function (activity, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: activity.key || idx,
                                      staticStyle: {
                                        "margin-bottom": "6px",
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "#606266",
                                          },
                                        },
                                        [_vm._v(_vm._s(activity.displayText))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            href:
                                              "/#/hike/action-setting/" +
                                              activity.hikeId,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                padding: "4px 8px",
                                              },
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                            },
                                            [_vm._v("Open")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#606266",
                                },
                              },
                              [_vm._v("\n              None\n            ")]
                            ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "fieldset",
                {
                  staticClass: "otrfieldset",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("legend", [_vm._v("1:1 Coaching Session Booking")]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Number of sessions per user:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              min: 0,
                              disabled: _vm.updateCount > 0,
                              size: "small",
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.sessionsPerUser,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sessionsPerUser", $$v)
                              },
                              expression: "form.sessionsPerUser",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "5px",
                              },
                            },
                            [
                              _vm._v(
                                "It is the max. number of 1:1 Coaching sessions that a user can book."
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.updateCount === 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#E6A23C",
                                    "margin-top": "5px",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              You cannot update this number after you save it.\n            "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#909399",
                                    "margin-top": "5px",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              This value is read-only because the subscription has been updated.\n            "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Total session quota:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 20 } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.handleQuotaTypeChange },
                                model: {
                                  value: _vm.quotaType,
                                  callback: function ($$v) {
                                    _vm.quotaType = $$v
                                  },
                                  expression: "quotaType",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  { attrs: { label: "unlimited" } },
                                  [_vm._v("Unlimited")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "limited" } },
                                  [_vm._v("Limited")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.quotaType === "limited"
                              ? _c("el-input-number", {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-left": "16px",
                                  },
                                  attrs: {
                                    min: 1,
                                    size: "small",
                                    "controls-position": "right",
                                  },
                                  on: { change: _vm.handleLimitedQuotaChange },
                                  model: {
                                    value: _vm.limitedQuotaValue,
                                    callback: function ($$v) {
                                      _vm.limitedQuotaValue = $$v
                                    },
                                    expression: "limitedQuotaValue",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-top": "5px",
                            },
                          },
                          [
                            _vm._v(
                              "It is the overall quota of 1:1 Coaching sessions in the subscription"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.quotaType === "limited" &&
                        Number(_vm.form.overallQuota) <
                          Number(_vm.form.sessionsPerUser)
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#F56C6C",
                                  "margin-top": "5px",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-error",
                                  staticStyle: { "margin-right": "4px" },
                                }),
                                _vm._v(
                                  "\n              Total session quota must be equal or greater than Number of sessions per user.\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "otr-line-spacing__20",
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 4 } }, [
                        _c("span", { staticClass: "otr-form__label" }, [
                          _vm._v("Booking expiry:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "Pick a day",
                            },
                            model: {
                              value: _vm.form.expiryDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "expiryDate", $$v)
                              },
                              expression: "form.expiryDate",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "5px",
                              },
                            },
                            [
                              _vm._v(
                                "User cannot book new session after this date. Leave it blank means no time restriction."
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "fieldset",
                {
                  staticClass: "otrfieldset",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("legend", [_vm._v("Coaches")]),
                  _vm._v(" "),
                  _vm.form.coaches.length > 0
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.form.coaches, border: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Order",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-button", {
                                        staticStyle: {
                                          "font-size": "16px",
                                          padding: "0 4px",
                                        },
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-top",
                                          disabled: scope.$index === 0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveCoachUp(scope.$index)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-button", {
                                        staticStyle: {
                                          "font-size": "16px",
                                          padding: "0 4px",
                                        },
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-bottom",
                                          disabled:
                                            scope.$index ===
                                            _vm.form.coaches.length - 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveCoachDown(
                                              scope.$index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3914034773
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Coach", width: "280" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "margin-bottom": "2px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.givenName) +
                                              " " +
                                              _vm._s(scope.row.familyName)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            color: "#606266",
                                            "margin-bottom": "1px",
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.email))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "11px",
                                            color: "#909399",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "UUID: " + _vm._s(scope.row.uuid)
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              635666589
                            ),
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "e.g. https://calendly.com/...",
                                            size: "small",
                                          },
                                          model: {
                                            value: scope.row.calendlyLink,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "calendlyLink",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.calendlyLink",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                553468945
                              ),
                            },
                            [
                              _c(
                                "template",
                                { slot: "header" },
                                [
                                  _c("span", [
                                    _vm._v("Calendly Event Type Link"),
                                    _c("span", { staticClass: "otr-red" }, [
                                      _vm._v("*"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "Example: https://calendly.com/lifehikes/john-doe",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                        staticStyle: {
                                          "margin-left": "5px",
                                          color: "#909399",
                                          cursor: "pointer",
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                        },
                                        model: {
                                          value: scope.row.enabled,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "enabled", $$v)
                                          },
                                          expression: "scope.row.enabled",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1384313207
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Remove",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          icon: "el-icon-delete",
                                          size: "mini",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeCoach(scope.$index)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              225017847
                            ),
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#909399",
                            "font-style": "italic",
                            "margin-bottom": "15px",
                          },
                        },
                        [_vm._v("No coaches added yet.")]
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "15px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", icon: "el-icon-plus" },
                          on: { click: _vm.openCoachDialog },
                        },
                        [_vm._v("Add Coach")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { name: "user-records", label: "User Records" } },
            [
              _vm.userRecordsStats && _vm.userRecordsStats.individualCoaching
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        gap: "20px",
                        "margin-bottom": "20px",
                        "flex-wrap": "wrap",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1",
                            "min-width": "200px",
                            "max-width": "300px",
                            padding: "15px",
                            "border-radius": "8px",
                            border: "1px solid #e0e0e0",
                            "background-color": "#fcfcfc",
                            "box-shadow": "0 2px 12px 0 rgba(0,0,0,.05)",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#ecf5ff",
                                padding: "10px",
                                "border-radius": "50%",
                                "margin-right": "15px",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "24px",
                                  color: "#409EFF",
                                },
                                attrs: { "icon-class": "education" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  color: "#909399",
                                  "margin-bottom": "5px",
                                },
                              },
                              [_vm._v("Total Eligible Sessions")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "20px",
                                  "font-weight": "bold",
                                  color: "#303133",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.userRecordsStats.individualCoaching
                                        .totalEligibleSessionCount || 0
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1",
                            "min-width": "200px",
                            "max-width": "300px",
                            padding: "15px",
                            "border-radius": "8px",
                            border: "1px solid #e0e0e0",
                            "background-color": "#fcfcfc",
                            "box-shadow": "0 2px 12px 0 rgba(0,0,0,.05)",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#f0f9eb",
                                padding: "10px",
                                "border-radius": "50%",
                                "margin-right": "15px",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "24px",
                                  color: "#67C23A",
                                },
                                attrs: { "icon-class": "hike" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  color: "#909399",
                                  "margin-bottom": "5px",
                                },
                              },
                              [_vm._v("Total Booked Sessions")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "20px",
                                  "font-weight": "bold",
                                  color: "#303133",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.userRecordsStats.individualCoaching
                                        .totalBookedSessionCount || 0
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1",
                            "min-width": "200px",
                            "max-width": "300px",
                            padding: "15px",
                            "border-radius": "8px",
                            border: "1px solid #e0e0e0",
                            "background-color": "#fcfcfc",
                            "box-shadow": "0 2px 12px 0 rgba(0,0,0,.05)",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#fdf6ec",
                                padding: "10px",
                                "border-radius": "50%",
                                "margin-right": "15px",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "24px",
                                  color: "#E6A23C",
                                },
                                attrs: { "icon-class": "chart" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  color: "#909399",
                                  "margin-bottom": "5px",
                                },
                              },
                              [_vm._v("Remaining Sessions")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "20px",
                                  "font-weight": "bold",
                                  color: "#303133",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Number(_vm.form.overallQuota) === 0 &&
                                        Number(_vm.form.sessionsPerUser) === 0
                                        ? 0
                                        : Number(_vm.form.overallQuota) === 0
                                        ? "unlimited"
                                        : Math.max(
                                            0,
                                            Number(_vm.form.overallQuota) -
                                              (_vm.userRecordsStats
                                                .individualCoaching
                                                .totalBookedSessionCount || 0)
                                          )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "Search by name or email...",
                        clearable: "",
                      },
                      on: { clear: _vm.handleUserRecordsSearch },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleUserRecordsSearch($event)
                        },
                      },
                      model: {
                        value: _vm.userRecordsQuery.search,
                        callback: function ($$v) {
                          _vm.$set(_vm.userRecordsQuery, "search", $$v)
                        },
                        expression: "userRecordsQuery.search",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.handleUserRecordsSearch },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-refresh",
                        size: "small",
                      },
                      on: { click: _vm.handleRefreshUserRecords },
                    },
                    [_vm._v("Refresh")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.userRecordsLoading,
                      expression: "userRecordsLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.userRecordsList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "User", "min-width": "240" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "14px",
                                  "margin-bottom": "2px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.user.givenName) +
                                    " " +
                                    _vm._s(scope.row.user.familyName) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#606266",
                                  "margin-bottom": "2px",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.user.email))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#909399",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "UUID: " +
                                      _vm._s(
                                        scope.row.user.uuid ||
                                          (scope.row.subscriptionRecord &&
                                            scope.row.subscriptionRecord
                                              .userUuid) ||
                                          scope.row.userUuid
                                      )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Steps", width: "160", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isStepCountPassing(scope.row)
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", size: "medium" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.getStepCount(scope.row)) +
                                        " / " +
                                        _vm._s(_vm.getMaxStepCount(scope.row)) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#606266" } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.getStepCount(scope.row)) +
                                        " / " +
                                        _vm._s(_vm.getMaxStepCount(scope.row)) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Check-in", width: "160", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isCheckinCountPassing(scope.row)
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      height: "auto",
                                      padding: "4px 8px",
                                      "line-height": "1.4",
                                    },
                                    attrs: { type: "success", size: "medium" },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.getCheckinCount(scope.row)) +
                                          " / " +
                                          _vm._s(
                                            _vm.getMaxCheckinCount(scope.row)
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { "font-size": "11px" } },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.getCheckinPercentage(
                                                scope.row
                                              )
                                            ) +
                                            "%)"
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#606266",
                                      "line-height": "1.4",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.getCheckinCount(scope.row)) +
                                          " / " +
                                          _vm._s(
                                            _vm.getMaxCheckinCount(scope.row)
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.getCheckinPercentage(
                                                scope.row
                                              )
                                            ) +
                                            "%)"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mandatory activity",
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "text-decoration": "none",
                                  display: "inline-block",
                                },
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewMandatoryActivities(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _vm.isMandatoryHikeActivityPassing(scope.row)
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          type: "success",
                                          size: "medium",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getCompletedMandatoryHikeActivityCount(
                                                scope.row
                                              )
                                            ) +
                                            " / " +
                                            _vm._s(
                                              _vm.getMandatoryHikeActivityCount(
                                                scope.row
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#1890ff",
                                          "font-weight": "bold",
                                          cursor: "pointer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getCompletedMandatoryHikeActivityCount(
                                                scope.row
                                              )
                                            ) +
                                            " / " +
                                            _vm._s(
                                              _vm.getMandatoryHikeActivityCount(
                                                scope.row
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "1:1 Coaching Unlock Progress",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("el-progress", {
                                  staticStyle: { width: "80%" },
                                  attrs: {
                                    percentage:
                                      _vm.getPassingCompletionRateValue(
                                        scope.row
                                      ),
                                    "show-text": false,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "bold",
                                      color: "#606266",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getPassingCompletionRateValue(
                                            scope.row
                                          )
                                        ) +
                                        "%\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "1:1 Coaching bookings",
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.subscriptionRecord.individualCoaching
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        color: "#1890ff",
                                        "font-weight": "bold",
                                      },
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewCoachingBookings(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            scope.row.subscriptionRecord
                                              .individualCoaching
                                              .bookedSessionCount || 0
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#909399",
                                            "font-weight": "normal",
                                          },
                                        },
                                        [_vm._v(" / ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#1890ff",
                                            "font-weight": "normal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.subscriptionRecord
                                                .individualCoaching
                                                .eligibleSessionCount || 0
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#c0c4cc" } },
                                  [_vm._v("-")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Status", width: "110", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: scope.row.subscriptionRecord.isDeleted
                                    ? "danger"
                                    : "success",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.subscriptionRecord.isDeleted
                                        ? "Deleted"
                                        : "Active"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "140", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.subscriptionRecord.changelog &&
                            scope.row.subscriptionRecord.changelog.length > 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-tickets",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewUserChangelog(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Changelog\n            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#c0c4cc",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v("No logs")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pagination-container",
                  staticStyle: { "margin-top": "15px" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.userRecordsQuery.page,
                      "page-sizes": [5, 10, 20, 50],
                      "page-size": _vm.userRecordsQuery.limit,
                      total: _vm.userRecordsTotal,
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleUserRecordsSizeChange,
                      "current-change": _vm.handleUserRecordsCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.doSave($event)
                },
              },
            },
            [_vm._v("Save")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.goBack($event)
                },
              },
            },
            [_vm._v("Back")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Select Loop",
            visible: _vm.dialogLoopVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLoopVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "Search by loop title...",
                        clearable: "",
                      },
                      on: { clear: _vm.searchLoops },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchLoops($event)
                        },
                      },
                      model: {
                        value: _vm.loopQuery.q,
                        callback: function ($$v) {
                          _vm.$set(_vm.loopQuery, "q", $$v)
                        },
                        expression: "loopQuery.q",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.searchLoops },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loopTableLoading,
                  expression: "loopTableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.loopList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Add", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.metadata && scope.row.metadata.subscriptionId
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "link-type",
                                  attrs: {
                                    href:
                                      "/#/subscriptions/edit/" +
                                      scope.row.metadata.subscriptionId,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Added in another Subscription\n            "
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addLoop(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("Add")]
                              ),
                            ],
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "ID", width: "220", prop: "id" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Title", prop: "title" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Internal Title" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.internal ? scope.row.internal.title : ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pagination-container",
              staticStyle: { "margin-top": "15px" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.loopQuery.page,
                  "page-sizes": [5, 10, 20],
                  "page-size": _vm.loopQuery.limit,
                  total: _vm.loopTotal,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleLoopSizeChange,
                  "current-change": _vm.handleLoopCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Select Coach",
            visible: _vm.dialogCoachVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCoachVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "Search by name or email...",
                        clearable: "",
                      },
                      on: { clear: _vm.searchCoaches },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchCoaches($event)
                        },
                      },
                      model: {
                        value: _vm.coachQuery.q,
                        callback: function ($$v) {
                          _vm.$set(_vm.coachQuery, "q", $$v)
                        },
                        expression: "coachQuery.q",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.searchCoaches },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.coachTableLoading,
                  expression: "coachTableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.coachList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Add", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.addCoach(scope.row)
                              },
                            },
                          },
                          [_vm._v("Add")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "UUID", prop: "uuid", width: "220" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Given Name", prop: "givenName" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Surname", prop: "familyName" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Email", prop: "email", width: "250" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pagination-container",
              staticStyle: { "margin-top": "15px" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.coachQuery.page,
                  "page-sizes": [5, 10, 20],
                  "page-size": _vm.coachQuery.limit,
                  total: _vm.coachTotal,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleCoachSizeChange,
                  "current-change": _vm.handleCoachCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Subscription Changelog - " + _vm.selectedUserName,
            visible: _vm.dialogChangelogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogChangelogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "450px",
                "overflow-y": "auto",
                padding: "10px 20px",
              },
            },
            [
              _vm.selectedUserChangelog && _vm.selectedUserChangelog.length > 0
                ? _c(
                    "el-timeline",
                    _vm._l(_vm.selectedUserChangelog, function (log, idx) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: log._id || idx,
                          attrs: {
                            timestamp: _vm.formatLogDate(log.createdAt),
                            placement: "top",
                            type: "primary",
                          },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticStyle: { "border-radius": "8px" },
                              attrs: { shadow: "hover" },
                            },
                            [
                              _c(
                                "h4",
                                {
                                  staticStyle: {
                                    margin: "0",
                                    "font-size": "14px",
                                    color: "#303133",
                                    "font-weight": "600",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(log.description) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        color: "#909399",
                        "font-style": "italic",
                        padding: "20px 0",
                      },
                    },
                    [
                      _vm._v(
                        "\n        No changelog history available.\n      "
                      ),
                    ]
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogChangelogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "1:1 Coaching Bookings - " + _vm.selectedUserName,
            visible: _vm.dialogBookingsVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBookingsVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.bookingsLoading,
                  expression: "bookingsLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.bookingsList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { padding: "10px 20px" } },
                          [
                            _c(
                              "h4",
                              {
                                staticStyle: {
                                  margin: "0 0 10px 0",
                                  "font-size": "13px",
                                  color: "#303133",
                                  "font-weight": "bold",
                                },
                              },
                              [_vm._v("Changelog History")]
                            ),
                            _vm._v(" "),
                            scope.row.changelog &&
                            scope.row.changelog.length > 0
                              ? _c(
                                  "el-timeline",
                                  _vm._l(
                                    scope.row.changelog,
                                    function (log, idx) {
                                      return _c(
                                        "el-timeline-item",
                                        {
                                          key: idx,
                                          attrs: {
                                            timestamp: _vm.formatLogDate(
                                              log.createdAt
                                            ),
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-card",
                                            {
                                              staticStyle: {
                                                "border-radius": "8px",
                                                "margin-bottom": "5px",
                                              },
                                              attrs: { shadow: "hover" },
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticStyle: {
                                                    margin: "0",
                                                    "font-size": "13px",
                                                    color: "#303133",
                                                    "font-weight": "600",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(log.description) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      color: "#909399",
                                      "font-style": "italic",
                                      padding: "10px 0",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              No changelog history available.\n            "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Coach", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.coachUuid
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.coachMap[scope.row.coachUuid] ||
                                      "Loading (" +
                                        scope.row.coachUuid.substring(0, 8) +
                                        ")..."
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _c("span", { staticStyle: { color: "#909399" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Status", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getBookingStatusType(scope.row.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.status) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Session Time", "min-width": "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.sessionStartTime &&
                        scope.row.sessionStartTime.utc
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatBookingTime(
                                      scope.row.sessionStartTime.utc
                                    )
                                  ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formatBookingTime(
                                        scope.row.sessionEndTime.utc
                                      )
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "11px",
                                    color: "#909399",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Timezone: " +
                                      _vm._s(
                                        scope.row.sessionStartTime.timezone ||
                                          "UTC"
                                      )
                                  ),
                                ]
                              ),
                            ])
                          : _c("span", { staticStyle: { color: "#909399" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogBookingsVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Mandatory Hike Activities - " + _vm.selectedUserName,
            visible: _vm.dialogMandatoryActivitiesVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogMandatoryActivitiesVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "15px",
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "flex-wrap": "wrap",
                gap: "10px",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { "font-size": "14px", color: "#606266" } },
                [
                  _vm._v("\n        Total Mandatory Activities: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.selectedUserMandatoryActivities.length)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { margin: "0 10px", color: "#dcdfe6" } },
                    [_vm._v("|")]
                  ),
                  _vm._v("\n        Completed: "),
                  _c("strong", { staticStyle: { color: "#67c23a" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.selectedUserMandatoryActivities.filter(function (
                          a
                        ) {
                          return a.isCompleted
                        }).length
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { margin: "0 10px", color: "#dcdfe6" } },
                    [_vm._v("|")]
                  ),
                  _vm._v("\n        Not Completed: "),
                  _c("strong", { staticStyle: { color: "#f56c6c" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.selectedUserMandatoryActivities.filter(function (
                          a
                        ) {
                          return !a.isCompleted
                        }).length
                      )
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.selectedUserMandatoryActivities, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Status", width: "140", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.isCompleted
                                ? "success"
                                : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.isCompleted
                                    ? "Completed"
                                    : "Not Completed"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Hike", "min-width": "160", prop: "hikeTitle" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { "font-weight": "500" } }, [
                          _vm._v(_vm._s(scope.row.hikeTitle)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Stage",
                  "min-width": "130",
                  prop: "stageTitle",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Activity",
                  "min-width": "140",
                  prop: "activityTitle",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Component",
                  "min-width": "140",
                  prop: "componentTitle",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Action", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "/#/hike/action-setting/" + scope.row.hikeId,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { padding: "4px 8px" },
                                attrs: { type: "primary", size: "mini" },
                              },
                              [_vm._v("Open")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogMandatoryActivitiesVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }